module.exports = __webpack_public_path__ + "img/2.9ce15a4d.svg";